// Размеры бокового списка категорий, px.
export const MENU_WIDTH = 440;
export const GAP = 8;
export const VIEWPORT_MARGIN = 8;

/** z-index портала: выше gravity Modal (1000) и его подложки. */
export const MENU_Z_INDEX = 1100;

/**
 * data-атрибут портала меню. По нему closeMenuOnScroll отличает скролл самого
 * списка (не закрывать) от скролла страницы/фильтров (закрыть).
 */
export const MENU_PORTAL_ATTR = "data-category-menu";
